import { getDecodedTokenFromAuthHeader } from "./AutAndAuthServices";

export const ADMIN_ROLE = "admin";
export const DIRECTOR_ROLE = "director";
export const MANAGER_ROLE = "manager";
export const ESTABLISHMENT_ADMIN_ROLE = "establishment_admin";

// Roles allowed to write establishment attribute values / dropdown options.
// Must match the backend permission specs.
export const ATTRIBUTE_VALUE_EDIT_ROLES = [
  ADMIN_ROLE,
  DIRECTOR_ROLE,
  ESTABLISHMENT_ADMIN_ROLE,
];
export const ATTRIBUTE_OPTION_EDIT_ROLES = [
  ADMIN_ROLE,
  ESTABLISHMENT_ADMIN_ROLE,
];
export const ATTRIBUTE_DEFINITION_EDIT_ROLES = [ADMIN_ROLE];

// Paths an establishment_admin may open; everything else redirects to
// ESTABLISHMENT_ADMIN_HOME.
export const ESTABLISHMENT_ADMIN_HOME = "/establishment";
const ESTABLISHMENT_ADMIN_PATHS = [
  "/establishment",
  "/establishment-attributes",
  "/profile",
  "/login",
];

export function getUserType(userTokenInfo) {
  return (
    userTokenInfo?.utype ||
    getDecodedTokenFromAuthHeader()?.token?.utype ||
    localStorage.getItem("userType")
  );
}

export function isEstablishmentAdminAllowedPath(path) {
  const lowerPath = path.toLowerCase();
  return ESTABLISHMENT_ADMIN_PATHS.some(
    (allowed) => lowerPath === allowed || lowerPath.startsWith(allowed + "/"),
  );
}
